module.exports = __webpack_public_path__ + "img/viewed-document-active.2fbd0573.svg";